import { h } from "vue";
import { ElNotification } from "element-plus";
import { faCircleCheck, faCircleExclamation } from "@awesome.me/kit-bda1b4ada1/icons/classic/solid";

const Icon = defineAsyncComponent(() => import("@/components/basics/Icon.vue"));

const Position = "bottom-left";
const Duration = 5000;

export const showSuccessToast = (message: string) => {
  ElNotification({
    message,
    icon: h(Icon, { icon: faCircleCheck }),
    customClass: "success",
    position: Position,
    duration: Duration,
  });
  const liveRegion = document.getElementById("toast-live-region");
  if (liveRegion) {
    liveRegion.textContent = message;
    setTimeout(() => {
      liveRegion.textContent = "";
    }, 1000);
  }
};

export const showErrorToast = (message: string) => {
  ElNotification({
    message,
    customClass: "error",
    icon: h(Icon, { icon: faCircleExclamation }),
    position: Position,
    duration: Duration,
  });
};
